import {charcoal} from '../sass/base/_exports.sass';

export const UploadIcon = ({color = charcoal, className = '', ratio = 1}) => {
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
    >
      <path
        d="M.85 28.631h30.316V32H.85zM17.692 6.447v18.816h-3.368V6.447L4.099 16.674l-2.382-2.382L16.008 0l14.29 14.29-2.38 2.382L17.691 6.45Z"
        fill={color}
      />
    </svg>
  );
};
